import { StyleSheet } from 'aphrodite';
import { defaultStyles } from '../../../library/styles/common';

const styles = StyleSheet.create({
    tileSizeRow: {
        position: 'relative',
        padding: '0 0 2rem 0',
        ':last-child': {
            border: 'none',
        },
        '@media print': {
            padding: '1rem 0 0',
        },
    },
    h3: {
        marginTop: 0,
    },
    tileSizeRowNumber: {
        marginBottom: '1rem',
        marginTop: '2rem',
        marginLeft: '40px',
        fontWeight: 'bold',
        color: defaultStyles.blue,
        '@media screen and (min-width: 990px)': {
            marginLeft: '65px',
        },
        '@media print': {
            marginBottom: '1rem',
        },
    },
    tileSizeContent: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: defaultStyles.greyWhite,
        '@media print, screen and (min-width: 990px)': {
            flexDirection: 'row',
        },
    },
    tileSizeText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '@media print, screen and (min-width: 990px)': {
            maxWidth: '70%',
            flex: '0 0 70%',
        },
    },
    tileSizeCloseWrapper: {
        position: 'absolute',
        width: '32px',
        top: '25px',
        right: '10px',
        transform: 'translateY(-50%)',
        zIndex: '10',
        '@media screen and (min-width: 990px)': {
            left: '15px',
            top: '50%',
        },
        '@media print': {
            display: 'none',
        }
    },
    tileSizeClose: {
        cursor: 'pointer',
    },
    inputsRegion: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '@media print, screen and (min-width: 700px)': {
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'flex-start',
        },
        '@media print, screen and (min-width: 990px)': {
            justifyContent: 'flex-start',
            paddingLeft: '25px',
        },
    },
    figure: {
        margin: '0',
        width: '100%',
        padding: '48px 0',
        backgroundColor: defaultStyles.greyBackground,
        '@media print, screen and (min-width: 990px)': {
            maxWidth: '30%',
            flex: '0 0 50%',
        },
    },
    image: {
        maxWidth: '80%',
        display: 'block',
        margin: '0 auto',
        '@media screen and (min-width: 990px)': {
            width: '200px',
        },
        '@media print': {
            maxWidth: '50%',
        }
    },
    error: {
        marginTop: '16px',
    },
    contentError: {
        border: '1px solid ' + defaultStyles.red,
    }
});

export default styles;